var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { getFrequencyLabel } from 'utils/GamesUtils';
import Meter from '../../Meter';
var Expectation = /** @class */ (function (_super) {
    __extends(Expectation, _super);
    function Expectation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Expectation.prototype.getLabel = function () {
        var label = '';
        if (this.props.isCurrency) {
            label += '$';
        }
        label += this.props.actual;
        label += ' / ';
        if (this.props.isCurrency) {
            label += '$';
        }
        label += this.props.goal;
        label += ' ';
        label += getFrequencyLabel(this.props.frequency);
        return label;
    };
    Expectation.prototype.render = function () {
        return (_jsxs("div", { className: "sb-expectations-trackable", children: [_jsx(Meter, { goal: this.props.goal, actual: this.props.actual }), _jsxs("div", { className: "sb-expectations-trackable-meta  g", children: [_jsx("div", { className: "u-sm-6 u-md-6", children: _jsx("span", { className: "sb-expectations-trackable-name", children: this.props.productName }) }), _jsx("div", { className: "u-sm-6 text-right u-md-6", children: _jsx("span", { className: "sb-expectations-trackable-info", children: this.getLabel() }) })] })] }));
    };
    return Expectation;
}(React.Component));
export default Expectation;
